




























import { Component, Vue,Prop } from 'vue-property-decorator'

@Component
export default class Login  extends Vue {
    @Prop(Object) riseData!: Object;
}
